(function () {
  function formatMoney(amount, currency) {
    try {
      return new Intl.NumberFormat('en-ZA', { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function updateRoot(root, totalCents) {
    var threshold = parseFloat(root.dataset.threshold, 10);
    if (!threshold || threshold < 1) return;

    var fill = root.querySelector('[data-free-shipping-progress-fill]');
    var message = root.querySelector('[data-free-shipping-progress-message]');
    var track = root.querySelector('.free-shipping-progress__track');
    if (!fill || !message) return;

    var currency = root.dataset.currency || 'ZAR';
    var unlockedMessage = root.dataset.unlockedMessage || '';
    var awayPrefix = root.dataset.awayPrefix || '';
    var awaySuffix = root.dataset.awaySuffix || '';

    var subtotal = Number(totalCents || 0) / 100;
    var remaining = Math.max(0, threshold - subtotal);
    var progress = Math.max(0, Math.min(100, (subtotal / threshold) * 100));
    var isComplete = remaining === 0;

    fill.style.width = (isComplete ? 100 : progress) + '%';
    fill.classList.toggle('is-complete', isComplete);

    if (track) {
      track.setAttribute('aria-valuenow', Math.min(subtotal, threshold));
    }

    if (isComplete) {
      message.textContent = unlockedMessage;
    } else {
      message.textContent = awayPrefix + ' ' + formatMoney(remaining, currency) + ' ' + awaySuffix;
    }
  }

  function updateAll(totalCents) {
    document.querySelectorAll('[data-free-shipping-progress]').forEach(function (root) {
      updateRoot(root, totalCents);
    });
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateAll(cart.total_price);
      })
      .catch(function () {});
  }

  function scheduleUpdate(delay) {
    setTimeout(fetchCartAndUpdate, delay || 100);
  }

  function bindListeners() {
    if (window.__freeShippingProgressBound) return;
    window.__freeShippingProgressBound = true;

    document.body.addEventListener('change', function (event) {
      if (event.target && event.target.closest('.quantity__input')) {
        scheduleUpdate(250);
      }
    });

    document.body.addEventListener('click', function (event) {
      if (
        event.target &&
        (event.target.closest('.quantity__button') || event.target.closest('cart-remove-button'))
      ) {
        scheduleUpdate(250);
      }
    });

    document.addEventListener('cart:updated', function () {
      scheduleUpdate(100);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        scheduleUpdate(200);
      });
    }
  }

  function init() {
    bindListeners();
    fetchCartAndUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
